import React from 'react'
import PropTypes from 'prop-types'

function UserCtaButton({
  pref = '', redirectLink = '', btnText, setCookie = false, btnClass = 'btn-primary',
}) {
  function handleClick(e) {
    e.preventDefault()

    if (setCookie) {
      storeJobPreference()
    }

    if (redirectLink) {
      window.open(redirectLink, '_blank')
    } else {
      openRegisterForm()
    }
  }

  function storeJobPreference() {
    Cookies.set('job_preference', pref)
  }

  function openRegisterForm() {
    App.events.publish('app:register:open', 'register', 'designPartnerships')
  }

  return (
    <button className={`cgt-button ${btnClass}`} onClick={handleClick}>{btnText}</button>
  )
}

UserCtaButton.propTypes = {
  pref: PropTypes.string,
  redirectLink: PropTypes.string,
  btnText: PropTypes.string.isRequired,
  setCookie: PropTypes.bool,
  btnClass: PropTypes.string,
}

export default UserCtaButton
